import * as React from "react";
import { Phone, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ContactUs() {
  return <section id="צרו-קשר" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto bg-muted/30 border border-border rounded-lg p-8 md:p-16 text-center shadow-sm">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground mb-4">
            זקוקים למידע נוסף? אנחנו כאן בשבילכם
          </h2>
          <p className="text-lg text-muted-foreground font-default mb-8 max-w-2xl mx-auto">
            צוות המומחים שלנו זמין לענות על כל שאלה ולסייע לכם למצוא את הפתרון המדויק והמתאים ביותר עבורכם. אל תהססו לפנות אלינו לקבלת ייעוץ אישי או המשיכו לחקור את מגוון השירותים שאנו מציעים.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="w-full sm:w-auto font-default">
              <Link to="/ContactPage">
                <Phone className="size-5 ml-2" />
                צרו קשר עכשיו
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto font-default">
              <Link to="/ServicesCitiesArticlesPage">
                לכל השירותים שלנו
                <ArrowLeft className="size-5 mr-2" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}